import { render, staticRenderFns } from "./naj-item-table.vue?vue&type=template&id=d40f2986&scoped=true&"
import script from "./naj-item-table.vue?vue&type=script&lang=js&"
export * from "./naj-item-table.vue?vue&type=script&lang=js&"
import style0 from "./naj-item-table.vue?vue&type=style&index=0&id=d40f2986&lang=scss&scoped=true&"
import style1 from "./naj-item-table.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40f2986",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCol,VDataIterator,VDivider,VHover,VIcon,VPagination,VProgressLinear})
